/* istanbul ignore file */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

// Simple drop down which sends isOpen attribute to children for mouse events
// Pass data-click-close to children to close dropdown on child click
export class SimpleDropdown extends React.Component {
    static displayName = 'SimpleDropdown';
    static propTypes = {
        className: PropTypes.string,
        disabled: PropTypes.bool,
        openOnHover: PropTypes.bool, // to enable hover events
        forceClosed: PropTypes.bool, // resets state to closed if true
        delayHoverEffect: PropTypes.bool,

        children: PropTypes.func.isRequired,
        onDropdownOpen: PropTypes.func,
        onDropdownClose: PropTypes.func,
    };

    state = {
        isOpen: false,
    };

    componentDidUpdate() {
        if (this.props.forceClosed)
            this.closeDropdown();
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.outsideClickHandler);
    }

    outsideClickHandler = () => {
        this.closeDropdown();
    };

    render() {
        return (
            <div
                className={this.props.className}
                ref="mouse-event-container"
                onClick={this.openDropdown}
                onMouseEnter={ this.props.openOnHover ?  this.openDropdown : undefined }
                onMouseLeave={ this.props.openOnHover ?  this.closeDropdown : undefined }>
                { this.props.children(this.state.isOpen, this.closeDropdown) }
            </div>
        );
    }

    openDropdown = (event, forceOpen = false) => {
        if (!this.props.disabled) {
            if (this.props.delayHoverEffect && !forceOpen) {
                setTimeout(() => {
                    this.openAfterDelay(event);
                }, 200);
            }
            else {
                if (!this.state.isOpen) {
                    this.setState({isOpen: true}, () => {
                        _.isFunction(this.props.onDropdownOpen) && this.props.onDropdownOpen(this.closeDropdown);
                    });
                    setTimeout(() => {
                        document.addEventListener('click', this.outsideClickHandler);
                    });
                }
                else {
                    if (!checkParentEnabledClose(event.target, this.refs['mouse-event-container'])) {
                        event.nativeEvent.stopImmediatePropagation();
                    }
                }
            }
        }
    };

    openAfterDelay = (event) => {
        if ($(this.refs['mouse-event-container']).is(':hover')) {
            this.openDropdown(event, true);
        }
        else {
            console.debug(`DEBUG: openAfterDelay -> missed hover train`); // eslint-disable-line no-console
        }
    };

    closeDropdown = () => {
        if (this.state.isOpen) {
            if (this.props.delayHoverEffect) { // delay closing menu only when delay hover effect is needed
                setTimeout(() => {
                    if (!$(this.refs['mouse-event-container']).is(':hover')) {
                        this.closeDropdownImpl();
                    }
                }, 200);
            }
            else {
                this.closeDropdownImpl();
            }
        }
    };

    closeDropdownImpl = () => {
        this.setState({isOpen: false}, this.props.onDropdownClose);
        document.removeEventListener('click', this.outsideClickHandler);
    }
}

function checkParentEnabledClose(child, parent) {
    while (child != parent) {
        if (child.getAttribute('data-click-close') === 'true')
            return true;
        child = child.parentElement;
    }
    return false;
}
